package br.com.vvrefeicoes.portal.domain.model

data class JuridicoEmpresa(
    val id: String,
    val nome: String,
    val cnpj: String,
    val tipo: String,
    val ativo: Boolean,
    val updatedAt: String? = null,
)

data class JuridicoEmpresaPage(
    val content: List<JuridicoEmpresa>,
    val totalPages: Int,
)
